export default "__VITE_ASSET__74f922e7__"